import { i18n } from 'i18next';
import memoize from 'lodash/memoize';

export const cloneI18n = memoize(
  (i18n: i18n, language: string) => {
    // TODO (436299): i18n issues crash storybook
    const clone = i18n.cloneInstance();
    void clone.changeLanguage(language);
    return clone;
  },
  (_i18n: i18n, language: string) => language
);
